import { reportInvoicesGroupedTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_INVOICES_GROUPED_FILTERS,
  RESTORE_INITIAL
} = reportInvoicesGroupedTypes;

const getInitialState = () => ({
  startDate: newDate(),
  endDate: newDate(),
  station: [],
});

export const reportInvoicesGroupedReducer = (state = getInitialState(), { type, payload }) => {
  switch (type) {
    case SET_INVOICES_GROUPED_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return getInitialState();

    default:
      return state;
  }
};
